const LS_KEYS = {
  AUTH_TOKEN_KEY: 'admin-auth-token',
  USER_DETAILS_KEY: 'admin-user-details',
  SITE_LANGUAGE_KEY: 'admin-site-language',
};

export default LS_KEYS;
